import $ from 'jquery';
import { Instrumentation } from '@bingads-webui/instrumentation';
import { AjaxStub, AjaxEventHandler, ErrorStub } from '@bingads-webui/instrumentation-stubs';
import { isInternalUrl } from '@bingads-webui/url-util';
import { schema } from './schema';
import { initSetup } from './setup';
import { initPerfTiming } from './perf-timing';

export const getInstrumentation = ({
  pageContext, config,
}) => {
  if (!pageContext || !config) {
    return {};
  }
  const { getListeners, getProcessors, getErrorMappers } = initSetup({
    pageContext, config,
  });
  const { perfTimingLogger } = initPerfTiming({
    pageContext, config,
  });
  const init = () => {
    const instrumentConfig = {
      listeners: getListeners(),
      processors: getProcessors(),
    };

    const instr = new Instrumentation(instrumentConfig);

    instr.addScenario(schema);
    return instr;
  };

  const stub = (instrumentation) => {
    const stubOptions = {
      objectsToStub: [$],
    };

    const errorMappers = getErrorMappers();
    const shouldAddHeaders = ajaxContext => isInternalUrl(ajaxContext.url);
    const eventHandler = new AjaxEventHandler({ errorMappers, shouldAddHeaders });

    const ajaxStub = new AjaxStub({
      stubOptions,
      eventHandler,
      instrumentation,
    });

    const errorStub = new ErrorStub({
      instrumentation,
    });

    ajaxStub.init();
    errorStub.init();
  };

  // init instrumentation
  const instrumentation = init();

  // init log stubs
  stub(instrumentation);

  // init performance timing logger
  perfTimingLogger.init();

  return {
    instrumentation,
  };
};

